module.exports = __webpack_public_path__ + "img/cat-sets.5f8d29f8.png";